import React from 'react';
import styled from 'styled-components';
import DropDown from '../../cm/common/DropDown';

const DetailsFilters = ({ className, filters, onChange, filterData }) => {
  return (
    <Container className={className}>
      <StyledDropDown
        label="Hit Level"
        placeholder={`Please select`}
        options={[
          {
            label: 'Low',
            value: 'Low'
          },
          {
            label: 'Good',
            value: 'Good'
          },
          {
            label: 'High',
            value: 'High'
          }
        ]}
        allowClear
        value={filters?.hitLevel}
        onChange={(value) => onChange('hitLevel', value)}
      />
      <StyledDropDown
        label="Watchlist Name"
        placeholder={`Please select`}
        options={filterData?.nameOfWatchlist.map((watch) => ({
          label: watch,
          value: watch
        }))}
        allowClear
        value={filters?.nameOfWatchlist}
        onChange={(value) => onChange('nameOfWatchlist', value)}
      />
      <StyledDropDown
        label="Watchlist Category"
        placeholder={`Please select`}
        options={filterData?.watchlistCategory.map((watch) => ({
          label: watch,
          value: watch
        }))}
        allowClear
        value={filters?.watchlistCategory}
        onChange={(value) => onChange('watchlistCategory', value)}
      />
      <StyledDropDown
        label="Watchlist Sub-Category"
        placeholder={`Please select`}
        options={filterData?.watchlistSubCategory.map((watch) => ({
          label: watch,
          value: watch
        }))}
        allowClear
        value={filters?.watchlistSubCategory}
        onChange={(value) => onChange('watchlistSubCategory', value)}
      />
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  & > * {
    margin-right: 22px;
  }
`;
const StyledDropDown = styled(DropDown)`
  width: 300px;
`;

export default DetailsFilters;
